import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { FUNCTIONS } from 'shared';
import { environment } from 'src/environments/environment';
import { IServerResponse } from '../types/server-response';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private url = `${environment.baseUrlAPI}/api/account`;

  constructor(private http: HttpClient) { }

  login = (credentials) => {
    const params = FUNCTIONS.ConvertObjectToGetParams(credentials);
    return this.http.get(`${this.url}/login`, { params, observe: 'response' }).pipe(
      map(response => {
        return response.headers.get('Authorization');
      }));
  }

  getMenu = (idPerfil: number) => {
    const params = FUNCTIONS.ConvertObjectToGetParams({ idPerfil });
    return this.http.get<IServerResponse<any[]>>(`${this.url}/menu`, { params });
  }

  getPerfil = (idUsuario: string) => {
    return this.http.get<any[]>(`${this.url}/perfil`, { params: { idUsuario } });
  }

  getPermisos = (idPerfil: number) => {
    const params = FUNCTIONS.ConvertObjectToGetParams({ idPerfil });
    return this.http.get<any[]>(`${this.url}/permisos`, { params });
  }
}
